module.exports = __webpack_public_path__ + "img/PAMMHeadModel.6a83cd5e.png";